import icon from '@assets/img/icons/security-settings.svg';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'セキュリティー',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  icon,
};
